module.exports = __webpack_public_path__ + "images/home/product/mobile/features-list-a1d7e6672ffbfc589753f2703d879c06.png";